import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import config from '../vue.config';
import 'element-ui/lib/theme-chalk/index.css';
import { doGet, doPost, doPut, doDelete } from '@/api/common'

import '@/assets/css/font.css';
import '@/assets/css/animate.min.css';

import '@/permission'

import vueSwiper from 'vue-awesome-swiper' // 引入vue-awesome-swiper
import 'swiper/css/swiper.css' // 引入样式
Vue.use(vueSwiper) // 使用插件
  
const bus = new Vue();
Vue.prototype.$bus = bus

// import Axios from 'axios'
// Vue.config.productionTip = false
// Vue.prototype.$axios = Axios;
// Axios.defaults.baseURL = '/'
// Axios.defaults.timeout = 60000;
// Axios.defaults.retry = 3;
Vue.prototype.$doGet = doGet;
Vue.prototype.$doPost = doPost;
Vue.prototype.$doPut = doPut;
Vue.prototype.$doDelete = doDelete;


import qs from 'qs';
// Vue.prototype.$ajax = axios // 把axios换成$ajax变量
Vue.prototype.$qs = qs;

//修改网页标题
Vue.directive('title', {
    inserted: function(el, binding) {
        document.title = el.dataset.title
    }
})


Vue.config.productionTip = false
Vue.use(ElementUI);

/**
 * 全局全屏loading
 * @param text  自定义显示文本（默认为：加载中，请稍候...），false关闭全屏loading
 * @param placement 文本显示位置，默认正中间：左上角top-left、右上角top-right、上中top-center、正中间center、左下角bottom-left、右下角角bottom-right、下中bottom-center
 * @param light true为浅色模式，默认深色模式
 */
Vue.prototype.$ing = Vue.prototype.$sxLoading = function (text, placement, light) {
  if (text === false) {
    this.$loading({}).close()
    return
  }
  const settings = ['top-left', 'top-right', 'top-center', 'center', 'bottom-left', 'bottom-right', 'bottom-center']
  placement = placement || 'center'
  placement = placement.toLowerCase()
  placement = settings.indexOf(placement) >= 0 ? placement : 'center'
  light = light !== true ? '' : ' sx-loading-light'
  this.$loading({
    text: text || '加载中，请稍候...',
    body: true,
    lock: true,
    spinner: 'el-icon-loading',
    customClass: 'sx-loading-wrap sx-loading-' + placement + light
  })
}


new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')